import { MotionConfig } from 'framer-motion';

import TopNav from '@/layouts/TopNav';
import { Footer } from '@/layouts/Footer';
import AiHero from './AiHero';
import AiSection from './AiSection';
import { AI_SECTIONS } from './sections';
import Seo from '@/components/seo/Seo';
import { ROUTE_SEO } from '@/config/seo';

/**
 * AI 랜딩 페이지.
 *
 * 기존 react-full-page 슬라이드(스냅 스크롤) 대신 자연스러운 세로 스크롤을 사용한다.
 * 다크 + 네온 테마에 섹션별 애니메이션 SVG 다이어그램으로 AI 인프라를 시각화한다.
 * (공공데이터 메인 views/home 은 기존 구조를 그대로 유지)
 */
export default function AiHomeIndex() {
  return (
    <MotionConfig reducedMotion="user">
      <Seo title={ROUTE_SEO.ai.title} description={ROUTE_SEO.ai.description} path={ROUTE_SEO.ai.path} />
      <div className="ai-home">
        <TopNav />
        <AiHero />

        {AI_SECTIONS.map((section) => (
          <AiSection key={section.titleAccent} {...section} />
        ))}

        <Footer />
      </div>
    </MotionConfig>
  );
}
